<template>
  <div class="main" id="review">
    <div class="row">
      <div class="banner_review pc">
        <h1>历届MPD</h1>
      </div>
      <div class="wap_banner_schedule mob">
        <h1>历届MPD</h1>
      </div>
    </div>
    <div class="review row">
      <div class="reviewz">
        <li v-for="(yitem,yindex) in year" :key="'year'+yindex">
          <div class="top row">
            <h1>{{yitem}}</h1>
          </div>
          <div class="bottom row">
            <div class="con row">
              <slot v-for="(item,index) in review[yitem]">
                <div class="li_text row" :key="'review'+yindex+index" v-if="item.id!='3199'">
                  <!-- <a :href="item.time<49?'../static/2020MPD/schedule.html?sid='+item.id:'/schedule?sid='+item.id"> -->
                  <a @click.prevent="toSchedule(item.time, item.id)">
                    <div class="le">
                      <h2>第{{item.time}}届</h2>
                    </div>
                    <div class="ri">
                      <h3>{{(global.config[item.id] && global.config[item.id].trueTitle) || item.title}}</h3>
                      <p>
                        {{item.address}}&nbsp;&nbsp;<br class="mob">
                        {{item.startTime}}<br>
                      </p>
                    </div>
                  </a>
                </div>
              </slot>
            </div>
          </div>
        </li>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
import $ from 'jquery'

export default {
  name: 'Review',
  data () {
    return {
      time: 0,
      year: [],
      review: []
    }
  },
  created () {
    this.getReview()
  },
  methods: {
    toSchedule: function (time, sid) {
      // console.log(time, sid, this.global.config[sid])
      if (this.global.config[sid] && this.global.config[sid].link) {
        window.open(this.global.config[sid].link, '_blank')
      } else if (this.global.config[sid] && this.global.config[sid].year >= this.global.limitYear) { // sid >= '4886'
        const address = (this.global.config[sid].address || (this.global.config[sid].year + (this.global.config[sid].jieshu || sid))) // 当前大会年份+地址简写
        this.$router.push({path: `/${address}/schedule`, name: `Schedule${address}`, query: {sid: sid}})
      } else if (time >= 49) {
        this.$router.push({path: '/schedule', name: 'Schedule', query: {sid: sid}})
      } else {
        // this.$router.push({path: `../static/2020MPD/schedule.html?sid=${sid}`})
        // location.reload()
        window.open(`/static/2020MPD/schedule.html?sid=${sid}`, '_self')
      }
    },
    getReview: function () {
      var url_review = this.global.url.review
      this.$http
        .jsonp(url_review)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          // console.log(data);
          this.review = []
          if (data.errno && data.errno.toString() === '0') {
            this.review = data.data
            this.year = Object.keys(data.data).reverse()
            for (let i = 0; i < Object.keys(data.data).reverse().length; i++) {
              this.time += data.data[Object.keys(data.data).reverse()[i]].length
            }
            this.time = parseInt(this.time)
            for (let i = 0; i < this.year.length; i++) {
              for (let j = 0; j < this.review[this.year[i]].length; j++) {
                this.review[this.year[i]][j].time = this.time--
                this.review[this.year[i]][j].startTime = this.global.formatTime(this.review[this.year[i]][j].startTime, 'Y.M.D')
              }
            }
            // console.log(this.time, this.year, this.review);
          }
        })
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/viewsNew/Review.vue